export const getContactCenterPhone = (): { text: string; href: string } => {
  return {
    text: '8 800 250 59 93',
    href: '88002505993',
  }
}

export const getHotlinePhone = (): { text: string; href: string } => {
  return {
    text: '8 800 234 44 18',
    href: '88002344418',
  }
}
